import { Injectable } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import { CohortTypeEnum } from 'src/portal/buyerscaddy-api/models/cohort-type-enum';
import { CompanyRefDto } from 'src/portal/buyerscaddy-api/models/company-ref-dto';
import { CohortService } from 'src/portal/buyerscaddy-api/services/cohort.service';
import { CompetitorPremiumApiService } from 'src/portal/owler-api/services/competitor-premium-api.service';

@Injectable({
  providedIn: 'root'
})
export class CohortDataService {

  public defaultCohortloaded: boolean = false
  public definedCohortloaded: boolean = false;
  public aspirationalCohortloaded: boolean = false;

  private pageSize = 100;


  constructor(private cohortService:CohortService,private competitorPremiumApiService:CompetitorPremiumApiService) { }

  public getDefaultCohort(): Observable<CompanyRefDto[]> {
    if (!this.cohortService) {
      throw new Error('cohortService is null');
    }
    this.defaultCohortloaded = true;
    return this.cohortService.getCohort({ cohort: CohortTypeEnum.DEFAULT,pageSize:this.pageSize}).pipe(
      finalize(() => this.defaultCohortloaded = false),
      catchError(err => {
        throw err;
      })
    );
  }

  public updateCohortDefault(body:CompanyRefDto[]){
    this.defaultCohortloaded = true;
    return this.cohortService.updateCohort({cohort:CohortTypeEnum.DEFAULT,body:body}).pipe(
      finalize(() => this.defaultCohortloaded = false),
      catchError(err => {
        throw err;
      })
    );
  }

  public removeCohortDefault(body:CompanyRefDto[]){
    this.defaultCohortloaded = true;
    return this.cohortService.deleteCohort({cohort:CohortTypeEnum.DEFAULT,body:body}).pipe(
      finalize(() => this.defaultCohortloaded = false),
      catchError(err => {
        throw err;
      })
    )
  }

  public getDefinedCohort(): Observable<CompanyRefDto[]> {
    if (!this.cohortService) {
      throw new Error('cohortService is null');
    }
    this.definedCohortloaded = true;
    return this.cohortService.getCohort({ cohort: CohortTypeEnum.DEFINED,pageSize:this.pageSize}).pipe(
      finalize(() => this.definedCohortloaded = false),
      catchError(err => {
        throw err;
      })
    );
  }

  public updateCohortDefined(body:CompanyRefDto[]){
    this.definedCohortloaded = true;
    return this.cohortService.updateCohort({cohort:CohortTypeEnum.DEFINED,body:body}).pipe(
      finalize(() => this.definedCohortloaded = false),
      catchError(err => {
        throw err;
      })
    );
  }
  public removeCohortDefined(body:CompanyRefDto[]){
    this.definedCohortloaded = true;
    return this.cohortService.deleteCohort({cohort:CohortTypeEnum.DEFINED,body:body}).pipe(
      finalize(() => this.definedCohortloaded = false),
      catchError(err => {
        throw err;
      })
    )
  }

  public getAspirationalCohort(): Observable<CompanyRefDto[]> {
    if (!this.cohortService) {
      throw new Error('cohortService is null');
    }
    this.aspirationalCohortloaded = true;
    return this.cohortService.getCohort({ cohort: CohortTypeEnum.ASPIRATIONAL,pageSize:this.pageSize}).pipe(
      finalize(() => this.aspirationalCohortloaded = false),
      catchError(err => {
        throw err;
      })
    );
  }

  public updateCohortAspirational(body:CompanyRefDto[]){
    this.aspirationalCohortloaded = true;
    return this.cohortService.updateCohort({cohort:CohortTypeEnum.ASPIRATIONAL,body:body}).pipe(
      finalize(() => this.aspirationalCohortloaded = false),
      catchError(err => {
        throw err;
      })
    )
  }

  public removeCohortAspirational(body:CompanyRefDto[]){
    this.aspirationalCohortloaded = true;
    return this.cohortService.deleteCohort({cohort:CohortTypeEnum.ASPIRATIONAL,body:body}).pipe(
      finalize(() => this.aspirationalCohortloaded = false),
      catchError(err => {
        throw err;
    }))
  }

  public setDefinedCompetotors(website) {
    this.definedCohortloaded = true
   return this.competitorPremiumApiService.getCompetitorsForWebsite({website: website})
      .pipe(
        map(res => ({
          competitor: res?.competitor?.slice(0, 10)?.map(x => x.website)
        })),
        catchError(error => {
          console.error('Ошибка:', error);
          return EMPTY;
        }),
        finalize(() => this.definedCohortloaded = false),
      );
  }

  public extractDomainsFromUrls(urls) {
    const domains = urls.map(url => {
      let domain = '';
      try {
        const parsedUrl = new URL(url);
        domain = parsedUrl.hostname.replace(/^www\./i, '');
      } catch (error) {
        // Handling URLs without protocol
        const domainWithoutProtocol = url.replace(/^(?:https?:\/\/)?(?:www\.)?/i, '');
        const index = domainWithoutProtocol.indexOf('/');
        domain = index !== -1 ? domainWithoutProtocol.substring(0, index) : domainWithoutProtocol;
        domain = domain.replace(/^www\./i, '');
      }
      // Exclude subdomains
      const domainParts = domain.split('.');
      if (domainParts.length > 2) {
        domain = domainParts.slice(-2).join('.');
      }

      // Removing unsuitable characters
      domain = domain.replace(/[^\w.-]/g, '');

      // Domain validity check
      const isValidDomain = /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(domain);
      return isValidDomain ? domain : null;
    });

    return domains.filter(domain => domain !== null);
  }
}
